import {Link, useLocation} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import {IconProp} from "@fortawesome/fontawesome-svg-core";

interface MenuButtonProps {
  path?: string;
  isCollapsed: boolean;
  icon: IconProp;
  name: string;
  onClick?: () => void;
}

const MenuButton = ({
  path = '',
  isCollapsed,
  icon,
  name,
  onClick = () => null,
}: MenuButtonProps) => {
  const location = useLocation();

  return (
    <li
      className={`
      mb-2 flex items-center p-2 rounded                  
      transform-gpu transition-transform duration-150 ease-out active:scale-90
      ${location.pathname === path ? "bg-ptTeal-100" : "hover:bg-ptTeal-100"}
    `}
      title={name}
    >
      <Link
        to={path ? path : undefined}
        onClick={path ? undefined : onClick}
        className="flex items-center space-x-2 transition-all w-full p-2 rounded text-center"
      >
        <FontAwesomeIcon
          icon={icon}
          className="w-8 text-xl"
        />
        {!isCollapsed && (
          <span className="ml-2">{name}</span>
        )}
      </Link>
    </li>
  )
}

export default MenuButton;